import echarts from 'echarts/lib/echarts'
/* import { legend } from 'echarts/lib/theme/dark' */
const myMixinfault = {
  mounted: function () {
    this.$nextTick(() => {
      // this.drawLine_aa()
      // this.drawLine_bb()
      // this.drawLine_cc()
    })
  },
  watch: {
  },
  methods: {
    drawLine_aa () {
      let vm = this
      // 为charts选定父容器并初始化charts画布
      let myChart = vm.$echarts.init(document.getElementById('chart1'))
      const data = [{
        name: '行波模块',
        value: vm.dtuCountList.kgDtuCount
      },
      {
        name: '架空型',
        value: vm.dtuCountList.jkDtuCount
      },
      {
        name: '电缆型',
        value: vm.dtuCountList.dlDtuCount
      }]
      const total = data.reduce((tot, num) => { // 数值的总数，用来计算百分比
        return (tot.value ? tot.value : tot) + num.value / 200
      })
      const colors = ['#048AFF', '#10D3C4', '#01B1FF'] // 自定义颜色组
      const arr = []
      data.map((item, index) => {
        arr.push({
          radius: ['50%', '63%'],
          center: [(index % 3) * 33.333 * 1.05 + 15 + '%', data.length > 3 ? (index < 3 ? '45%' : '75%') : '55%'],
          hoverAnimation: false,
          clockwise: false,
          type: 'pie',
          label: {
            show: true,
            position: 'center',
            formatter: [
              '{b|{b}}',
              '{d|' + (item.value) + '}'
              // '{d|' + (item.value / total * 100).toFixed(2) + '%}'
            ].join('\n'),
            rich: {
              b: {
                color: '#353535',
                fontSize: 12,
                // fontFamily: '楷体',
                fontWeight: 400,
                height: 30
              },
              d: {
                // fontFamily: 'cursive',
                color: colors[index],
                fontSize: 13
              }
            }
          },
          data: [{
            ...item,
            itemStyle: {
              normal: {
                color: colors[index]
              },
              emphasis: {
                color: colors[index]
              }
            }
          },
          {
            value: total,
            itemStyle: {
              normal: {
                color: '#C8DDE9'
              },
              emphasis: {
                color: '#C8DDE9'
              }
            }
          }
          ]
        })
      })
      // 为图表添加数据
      myChart.setOption({
        backgroundColor: 'rgba(0,0,0,0)',
        xAxis: {
          show: false
        },
        yAxis: {
          show: false
        },
        series: arr
      })
    },
    drawLine_bb () {
      let vm = this
      // 想显示成几条那么就把6改成几就可以了，dataAxis是横坐标的长度(倒序排列)
      var start = vm.MonthDiaresList.monthList.length - 5
      var end = vm.MonthDiaresList.monthList.length
      // 为charts选定父容器并初始化charts画布
      let myChart = vm.$echarts.init(document.getElementById('chart2'))

      // 为图表添加数据
      myChart.setOption({
        dataZoom: [
          // X轴内置滑动
          {
            type: 'inside', // 内置滑动，随鼠标滚轮展示
            zoomLock: true,
            xAxisIndex: [0],
            startValue: start,
            endValue: end// 数组最后1个的 index
            // start: 80, // 初始化时，滑动条宽度开始标度
            // end: 100 // 初始化时，滑动条宽度结束标度
          } ],
        grid: {
          top: '20px',
          right: '15px',
          left: '15px',
          bottom: '20px'
        },
        xAxis: [{
          type: 'category',
          data: vm.MonthDiaresList.monthList,
          axisLine: {
            lineStyle: {
              color: '#E4E4E4'
            }
          },
          axisLabel: {
            // margin: 10,
            color: '#6E6E6E',
            textStyle: {
              fontSize: 11
            }
          }
        }],
        yAxis: [{
          show: false,
          max: vm.MonthDiaresList.max + 20, // 设置y轴最大值+10
          boundaryGap: true,
          axisLabel: {
            formatter: '{value}',
            color: '#e2e9ff'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,1)'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.12)'
            }
          }
        }],
        series: [{
          type: 'bar',
          data: vm.MonthDiaresList.countList,
          barWidth: '10px',
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#11D5C4' // 0% 处的颜色
              }, {
                offset: 1,
                color: '#007FF5' // 100% 处的颜色
              }], false),
              barBorderRadius: [30, 30, 30, 30],
              shadowColor: 'rgba(0,160,221,1)',
              shadowBlur: 4
            }
          },
          label: {
            normal: {
              show: true,
              // lineHeight: 20,
              // width: 40,
              // height: 20,
              padding: [3, 3],
              backgroundColor: '#F2F2F2',
              borderRadius: 20,
              position: ['-8', '-30'],
              // distance: 1,
              formatter: [
                '{d|●}{a|{c}}{b|}'
                // ' {a|{c}}     \n',
                // '    {b|}'
              ].join(','),
              rich: {
                d: {
                  color: '#10D3C4'// 圆点颜色
                },
                a: {
                  color: '#353535', // 文字颜色
                  fontSize: 12,
                  align: 'right'
                },
                b: {
                  width: 1,
                  height: 11,
                  borderWidth: 1,
                  // color: 'yellow',
                  borderColor: '#F2F2F2', // 竖线颜色
                  align: 'center',
                  margin: 20

                }
              }
            }
          }
        }]
      })
    },
    drawLine_cc () {
      const data = [{
        name: '接地',
        precent: this.DiaresTypeList.jdbfb,
        value: this.DiaresTypeList.jdCount
      },
      {
        name: '速断',
        precent: this.DiaresTypeList.sdbfb,
        value: this.DiaresTypeList.sdCount
      },
      {
        name: '过流',
        precent: this.DiaresTypeList.glbfb,
        value: this.DiaresTypeList.glCount
      },
      {
        name: '瞬时性短路',
        precent: this.DiaresTypeList.ssxdlbfb,
        value: this.DiaresTypeList.ssxdlCount
      }]

      let vm = this
      // 为charts选定父容器并初始化charts画布
      let myChart = vm.$echarts.init(document.getElementById('chart3'))

      // 为图表添加数据
      myChart.setOption({
        legend: {
          selectedMode: true, // 取消图例上的点击事件
          type: 'plain',
          icon: 'circle',
          orient: 'vertical',
          left: '0',
          top: '10%',
          align: 'left',
          itemGap: 15,
          itemWidth: 6, // 设置宽度
          itemHeight: 6, // 设置高度
          symbolKeepAspect: false,
          textStyle: {
            color: '#000',
            rich: {
              name: {
                verticalAlign: 'left',
                align: 'left',
                width: 70,
                fontSize: 12,
                // height: 20,
                // lineHeight: 20
                // backgroundColor:'red'
              },
              precent: {
                align: 'left',
                width: 60,
                fontSize: 12
              },
              value: {
                align: 'left',
                width: 60,
                fontSize: 12
              }
            }
          },
          data: data.map(item => item.name),
          formatter: function (name) {
            if (data && data.length) {
              for (var i = 0; i < data.length; i++) {
                if (name === data[i].name) {
                  return (
                    '{name| ' +
                             name +
                             '}' +
                             '{precent| ' +
                             data[i].precent +
                             '%}' +
                             '{value| ' +
                             data[i].value +
                             '次}'

                  )
                }
              }
            }
          }
        },
        grid: {
          top: '20px',
          right: '15px',
          left: '15px',
          bottom: '20px'
        },
        series: [{
          name: '数量',
          type: 'pie',
          radius: ['50%', '65%'],
          center: ['80%', '50%'],
          color: ['#10D3C4', '#F2B12F', '#097EF4', '#E85B45'],
          data: data,
          itemStyle: {
            normal: {
                borderColor: '#fff',
                borderWidth: 1
            }
          },
          label: {
            normal: {
              show: false,
              position: 'center'

            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: '12'
              }
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          }
        }]
      })
    }
  }
}
export default myMixinfault
